import React, { FC } from 'react';

import { Link } from '~/src/ui/link';
import { TLanguageCode } from '~/src/root.types';

export type Form = {
  titleForm?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  company?: string;
  projects?: string;
  location?: string;
  message?: string;
  Subscribe: FC;
  agreement?: string;
  submit?: string;
};

type Submitted = {
  title: string;
  desription: string;
};

type LangReturn = {
  TitlePage: FC;
  desriptionPage: string;
  benefitsList: string[];
  formFields: Form;
  submittedPage: Submitted;
};

const TitleEN:FC = () => (
  <>
    Contact our sales team about Pushwoosh&apos;s software
  </>
);

const TitleES:FC = () => (
  <>
    Descubre las soluciones de interacción con el cliente de Pushwoosh
  </>
);

const PrivacyPolicyEN:FC = () => (
  <>
    I agree to Pushwoosh
    {' '}
    <Link href="https://www.pushwoosh.com/privacy-policy/" title="Privacy Policy" target="_blank">
      Privacy Policy.
    </Link>
  </>
);

const PrivacyPolicyES:FC = () => (
  <>
    Acepto
    {' '}
    <Link href="https://www.pushwoosh.com/privacy-policy/" title="Privacy Policy" target="_blank">
      la Política de privacidad
    </Link>
    {' '}
    de Pushwoosh.
  </>
);

const languageList = {
  EN: {
    TitlePage: TitleEN,
    desriptionPage: "Secure a call with our sales team to explore how Pushwoosh's enterprise features can improve your engagement, retention, ROI, and LTV.",
    benefitsList: [
      'We‘ll reach out to schedule a time for your demo. Feel free to ask as many questions as you need to help us personalize the demo for you.',
      'Share your specific use cases and needs beforehand so that our experts showcase the solutions that match your needs.',
      'Together, we‘ll review the platform and address any questions you have. We‘ll make sure to highlight relevant parts of the platform based on your specific requirements.',
    ],
    formFields: {
      titleForm: 'TALK TO SALES',
      firstName: 'First name...',
      lastName: 'Last name...',
      email: 'Email...',
      phone: 'Phone number...',
      company: 'Company',
      projects: 'Your project’s MAU...',
      location: 'Country...',
      message: 'Message...',
      Subscribe: PrivacyPolicyEN,
      agreement: 'I would like to receive growth insights, industry data, and product news from Pushwoosh.',
      submit: 'Send a request',
    },
    submittedPage: {
      title: 'Thank you for your interest!',
      desription: 'Your request has been successfully submitted. Our team will reach out to you shortly. In the meantime, get your first glimpse of the Pushwoosh platform:',
    },
  },
  ES: {
    TitlePage: TitleES,
    desriptionPage: 'Nuestro experimentado equipo te mostrará Pushwoosh en acción, responderá a tus preguntas y ofrecerá el mejor plan para las necesidades de tu negocio.',
    benefitsList: [
      'Explora el siguiente nivel del engagement del usuario con notificaciones push altamente personalizadas y basadas en el comportamiento',
      'Maximiza la retención de clientes e impulsa las conversiones gracias a las comunicaciones cross-channel (notificaciones push mobile y web, mensajes in-app, correo electrónico, WhatsApp y SMS)',
      'Mejora el targeting de tus campañas con segmentación avanzada y análisis RFM',
    ],
    formFields: {
      titleForm: 'HABLA CON EL EQUIPO DE PUSHWOOSH',
      firstName: 'Tu nombre...',
      lastName: 'Tu apellido...',
      email: 'Tu correo electrónico...',
      phone: 'Tu número de teléfono...',
      company: 'Empresa...',
      projects: 'El número de los MAU de tu proyecto...',
      location: 'País...',
      message: 'Comentarios...',
      Subscribe: PrivacyPolicyES,
      agreement: 'Me gustaría recibir contenido educativo de Pushwoosh (artículos de blog, guías, webinars, etc.)',
      submit: 'Enviar solicitud',
    },
    submittedPage: {
      title: '¡GRACIAS POR TU INTERÉS!',
      desription: 'Tu solicitud ha sido enviada exitosamente. Nuestro equipo se pondrá en contacto contigo en breve. Mientras tanto, obtén tu primer vistazo a la plataforma Pushwoosh:',
    },
  },
};

export const getContentByLanguage = (language:TLanguageCode):LangReturn => (languageList[language] || languageList.EN);
